import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class StrengthPelvicFloorElevation extends React.Component {

    render() {
        let dropdownOptions = [
            { id: 'absent', value: 'absent' },
            { id: 'present', value: 'present' }
        ];

        return (
            <div>
                    <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Strength - Pelvic Floor Elevation'/>
                        <label className={styles.textarea_label}>Pelvic Floor Elevation</label>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field='STPELVICFLOORELEVR'
                            className={styles.r}
                            customOptions={dropdownOptions}
                        />
                        <span className={styles.c} >
                            <span className={styles.prev_wrapper}>
                                {this.props.prevElevR}
                            </span>
                        </span>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESTR'
                            entityKeyColumn='STNO'
                            entityKeyValue={this.props.stno}
                            field='STPELVICFLOORELEVL'
                            className={styles.l}
                            customOptions={dropdownOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevElevL}
                        </span>
                    </div>
                </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let prevElevR = '';
    let prevElevL = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
        prevElevR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPELVICFLOORELEVR'];
        prevElevL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPELVICFLOORELEVL'];
    }

    return {
        noteId,
        stno,
        flagged: state.entities.notes.PTOBJECTIVESTR[stno]?.STPELVICFLOORELEVR !== null && state.entities.notes.PTOBJECTIVESTR[stno]?.STPELVICFLOORELEVL !== null,
        prevElevR,
        prevElevL,
    };
}

const connectedStrengthPelvicFloorElevation = connect(mapStateToProps)(StrengthPelvicFloorElevation);
export { connectedStrengthPelvicFloorElevation as StrengthPelvicFloorElevation };


